import React from 'react';

import styled, { css } from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const getPositionStyle = (position, offset) => {
    switch (position) {
        case 'topRight':
        case 'top-right':
            return css`
                top: ${offset}px;
                right: ${offset}px;
            `;
        case 'bottomLeft':
        case 'bottom-left':
            return css`
                bottom: ${offset}px;
                left: ${offset}px;
            `;
        case 'bottomRight':
        case 'bottom-right':
            return css`
                right: ${offset}px;
                bottom: ${offset}px;
            `;
        case 'topLeft':
        case 'top-left':
        default:
            return css`
                top: ${offset}px;
                left: ${offset}px;
            `;
    }
};

const TimesButtonWrapper = styled.span`
    position: relative;
    display: inline-block;
    max-width: 100%;
`;

const StyledTimesButton = styled.button`
    position: ${(props) => (props.$inline ? 'relative' : 'absolute')};
    ${(props) => !props.$inline && getPositionStyle(props.$position, props.$offset)}
    z-index: 2;
    width: ${(props) => props.$size}px;
    height: ${(props) => props.$size}px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background-color: ${(props) => (props.$primary ? props.theme.PrimaryColor : props.theme.DangerColor)};
    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.28);
    color: #fff;
    cursor: pointer;
    line-height: 0;
    transition:
        box-shadow 0.15s ease,
        transform 0.15s ease;

    svg {
        width: 100%;
        height: 100%;
        display: block;
        --fa-primary-color: #fff;
        --fa-secondary-color: ${(props) => (props.$primary ? props.theme.PrimaryColor : props.theme.DangerColor)};
        --fa-primary-opacity: 1;
        --fa-secondary-opacity: 1;
    }

    &:hover,
    &:focus-visible {
        box-shadow:
            0 0 0 2px rgba(255, 255, 255, 0.85),
            0 4px 12px rgba(0, 0, 0, 0.38);
        outline: none;
        transform: translateY(-1px) scale(1.06);
    }

    &:active {
        transform: scale(0.98);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.45;
        transform: none;
    }
`;

const NwTimesButton = ({
    ariaLabel = 'Remove',
    children,
    className,
    inline = false,
    offset = -10,
    onClick,
    position = 'top-right',
    primary = false,
    size = 26,
    stopPropagation = true,
    style,
    title,
    ...other
}) => {
    const handleClick = (event) => {
        if (stopPropagation) {
            event.stopPropagation();
        }
        if (onClick) {
            onClick(event);
        }
    };

    const button = (
        <StyledTimesButton
            $inline={inline}
            $offset={offset}
            $position={position}
            $primary={primary}
            $size={size}
            aria-label={ariaLabel}
            className={!children ? className : undefined}
            onClick={handleClick}
            style={!children ? style : undefined}
            title={title || ariaLabel}
            type="button"
            {...other}
        >
            <NwIcon icon={byPrefixAndName.fasds['circle-xmark']} />
        </StyledTimesButton>
    );

    if (!children) {
        return button;
    }

    return (
        <TimesButtonWrapper className={className} style={style}>
            {children}
            {button}
        </TimesButtonWrapper>
    );
};

export default NwTimesButton;
